module.exports = __webpack_public_path__ + "img/9.74515a08.svg";